import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CommandBase, MultiselectCommand } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { NativeWindowService } from '../../../core/service/native-window.service';
import { InvoiceReminderService } from '../data/invoice-reminder.service';
import { InvoiceReminderCommand } from '../../command/invoice-reminder';

@Injectable()
export class InvoiceReminderExportCommandHandler implements ICommandHandler {
  constructor(
    private _dataService: InvoiceReminderService,
    private _nativeWindow: NativeWindowService
  ) {}

  canExecute(command: CommandBase): boolean {
    if (command instanceof MultiselectCommand) {
      return command.id === InvoiceReminderCommand.export && command.itemsSource.length > 0;
    }
    return false;
  }

  execute(command: CommandBase): Observable<void> {
    if (command instanceof MultiselectCommand) {
      return this._dataService.export(command.items.map(item => item.id)).pipe(map(file => this._nativeWindow.save(file)));
    }
  }
}
